module.exports = __webpack_public_path__ + "static/img/p24-1-ch.2cf2ee8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/p24-1-ch.png
// module id = cJIs
// module chunks = 6